var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaximize2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19.875C32.385 19.875 31.875 20.385 31.875 21V22.875H25.125V16.125H27C27.615 16.125 28.125 15.615 28.125 15C28.125 14.385 27.615 13.875 27 13.875H21C20.385 13.875 19.875 14.385 19.875 15C19.875 15.615 20.385 16.125 21 16.125H22.875V22.875H16.125V21C16.125 20.385 15.615 19.875 15 19.875C14.385 19.875 13.875 20.385 13.875 21V27C13.875 27.615 14.385 28.125 15 28.125C15.615 28.125 16.125 27.615 16.125 27V25.125H22.875V31.875H21C20.385 31.875 19.875 32.385 19.875 33C19.875 33.615 20.385 34.125 21 34.125H27C27.615 34.125 28.125 33.615 28.125 33C28.125 32.385 27.615 31.875 27 31.875H25.125V25.125H31.875V27C31.875 27.615 32.385 28.125 33 28.125C33.615 28.125 34.125 27.615 34.125 27V21C34.125 20.385 33.615 19.875 33 19.875Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize2);
export default __webpack_public_path__ + "static/media/maximize2.e81ec899840b050c84c7f6789bd01cfd.svg";
export { ForwardRef as ReactComponent };